import React from "react";
import "./App.css";
import {
  HashRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";
import Header from "./components/Header/index";
import Proposal from "./proposal/index";
import ClosedProposal from "./history/index";
import VoteProposal from "./vote/index";
import Contract from "./contract/index"
import Transfer from "./transfer/index"

function App() {

  return (
    <div>
      <Router >
        <Header />
        <Route exact path="/" component={Proposal} />
        <Route path="/history" component={ClosedProposal} />
        <Route path="/vote" component={VoteProposal} />
        <Route path="/transfer" component={Transfer} />
        <Route path="/contract" component={Contract} />
      </Router>
    </div>
  );
}

export default App;
